import { render, staticRenderFns } from "./PermissionRoleEdit.vue?vue&type=template&id=5f1d0503&scoped=true"
import script from "./PermissionRoleEdit.vue?vue&type=script&lang=js"
export * from "./PermissionRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d0503",
  null
  
)

export default component.exports